import { createSelector } from 'reselect'
import { RootState } from '../types'

export const authStateSelector = (state: RootState) => state.auth

export const accessTokenSelector = createSelector(authStateSelector, auth => auth.accessToken)

export const isUserLoggedInSelector = createSelector(accessTokenSelector, accessToken => !!accessToken)

export const logInPendingSelector = createSelector(authStateSelector, auth => auth.logInPending)

export const logInErrorSelector = createSelector(authStateSelector, auth => auth.logInError)
